import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { FaSearch } from "react-icons/fa";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";

const ReferralList = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const {
  isOpen,
  onOpen,
  onClose,
} = useDisclosure();

const [selectedUsers, setSelectedUsers] = useState([]);

  const fetchReferrals = async (p = 1, searchTerm = "", status = "") => {
    setLoading(true);
    try {
      let url = `/admin/referral/all?page=${p}&limit=20`;
      if (searchTerm) url += `&search=${encodeURIComponent(searchTerm)}`;
      if (status) url += `&status=${status}`;
      const res = await axios.get(url);
      if (res.data?.result) {
        setReferrals(res.data.result.referrals);
        setPagination(res.data.result.pagination);
      }
    } catch (error) {
      console.error("Error fetching referrals", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReferrals(1);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchReferrals(1, search, statusFilter);
  };

  const handleStatusChange = (e) => {
    const val = e.target.value;
    setStatusFilter(val);
    setPage(1);
    fetchReferrals(1, search, val);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchReferrals(newPage, search, statusFilter);
  };

  const getTotalReward = (ref) => {
    return (ref.signupReward || 0) + (ref.firstRechargeReward || 0) + (ref.planPurchaseReward || 0);
  };

  return (
    <div className="p-4 lg:p-6">
      <h1 className="text-2xl font-bold text-bgBlue mb-6">All Referrals</h1>

      {/* Filters */}
      <div className="bg-white rounded-xl p-4 mb-6 shadow-sm flex flex-col lg:flex-row gap-4">
        <form onSubmit={handleSearch} className="flex-1 flex gap-2">
          <div className="relative flex-1">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name, email, mobile, or code..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-bgBlue"
            />
            <FaSearch className="absolute left-3 top-3 text-gray-400" />
          </div>
          <button
            type="submit"
            className="px-6 py-2 bg-bgBlue text-white rounded-lg font-semibold"
          >
            Search
          </button>
        </form>
        <select
          value={statusFilter}
          onChange={handleStatusChange}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-bgBlue"
        >
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="rewarded">Rewarded</option>
        </select>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-bgBlue"></div>
          </div>
        ) : referrals.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <p className="text-lg">No referrals found</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">#</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Referrer</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Code</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Referred User</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Status</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Signup</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Recharge</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Plan</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Total</th>
                  <th className="text-left py-3 px-4 text-gray-500 font-semibold">Date</th>
                </tr>
              </thead>
              <tbody>
                {referrals.map((ref, idx) => (
                  <tr key={ref._id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-3 px-4 text-gray-500">
                      {(page - 1) * 20 + idx + 1}
                    </td>
                    <td className="py-3 px-4">
                      <p className="font-semibold text-bgBlue">
                        {ref.referrer?.name || ref.referrer?.mobile || "—"}
                      </p>
                      <p className="text-xs text-gray-400">{ref.referrer?.email}</p>
                      <p className="text-xs text-gray-400">{ref.referrer?.mobile}</p>
                    </td>
                    <td className="py-3 px-4">
                      <span className="font-mono text-xs bg-gray-100 px-2 py-1 rounded">
                        {ref.referralCode}
                      </span>
                    </td>
                   <td className="py-3 px-4">
  <div className="flex items-center gap-2">
    <span className="font-semibold">
      {ref.totalUsers} User{ref.totalUsers > 1 ? "s" : ""}
    </span>

    {ref.referredUsers?.length > 0 && (
      <button
        onClick={() => {
          setSelectedUsers(ref.referredUsers);
          onOpen();
        }}
        className="text-bgBlue underline text-sm font-medium"
      >
        View
      </button>
    )}
  </div>
</td>
                    <td className="py-3 px-4">
                      <StatusBadge status={ref.status} />
                    </td>
                    <td className="py-3 px-4">
                      {ref.signupReward ? (
                        <span className="font-bold text-green-600">+{ref.signupReward}</span>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>
                    <td className="py-3 px-4">
                      {ref.rechargeReward ? (
                        <span className="font-bold text-green-600">+{ref.firstRechargeReward}</span>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>
                    <td className="py-3 px-4">
                      {ref.planReward ? (
                        <span className="font-bold text-green-600">+{ref.planPurchaseReward}</span>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>
                    <td className="py-3 px-4 font-bold text-bgBlue">
                      {getTotalReward(ref) > 0 ? `+${getTotalReward(ref)}` : "—"}
                    </td>
                    <td className="py-3 px-4 text-gray-500 text-xs">
                      {new Date(ref.createdOn).toLocaleDateString("en-IN")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        {pagination && pagination.totalPages > 1 && (
          <div className="flex justify-between items-center px-4 py-3 border-t border-gray-100">
            <p className="text-sm text-gray-500">
              Showing {(page - 1) * 20 + 1}–{Math.min(page * 20, pagination.total)} of {pagination.total}
            </p>
            <div className="flex gap-1">
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
                className="px-3 py-1 rounded text-sm bg-gray-100 text-gray-600 disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: Math.min(pagination.totalPages, 5) }, (_, i) => {
                const start = Math.max(1, page - 2);
                const p = start + i;
                if (p > pagination.totalPages) return null;
                return (
                  <button
                    key={p}
                    onClick={() => handlePageChange(p)}
                    className={`px-3 py-1 rounded text-sm ${
                      p === page ? "bg-bgBlue text-white" : "bg-gray-100 text-gray-600"
                    }`}
                  >
                    {p}
                  </button>
                );
              })}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page === pagination.totalPages}
                className="px-3 py-1 rounded text-sm bg-gray-100 text-gray-600 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
  <ModalOverlay />
  <ModalContent>
    <ModalHeader>Referred Users</ModalHeader>
    <ModalCloseButton />

    <ModalBody pb={6}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="text-left py-3 px-4">#</th>
              <th className="text-left py-3 px-4">Name</th>
              <th className="text-left py-3 px-4">Email</th>
              <th className="text-left py-3 px-4">Mobile</th>
              <th className="text-left py-3 px-4">Plan</th>
              <th className="text-left py-3 px-4">Created On</th>
            </tr>
          </thead>

          <tbody>
            {selectedUsers.map((user, index) => (
              <tr
                key={user._id}
                className="border-b"
              >
                <td className="py-3 px-4">
                  {index + 1}
                </td>

                <td className="py-3 px-4 font-medium">
                  {user.name}
                </td>

                <td className="py-3 px-4">
                  {user.email}
                </td>

                <td className="py-3 px-4">
                  {user.mobile}
                </td>

                <td className="py-3 px-4">
                  {user.planName || "-"}
                </td>

                <td className="py-3 px-4">
                  {new Date(user.createdOn).toLocaleDateString("en-IN")}
                </td>
              </tr>
            ))}

            {selectedUsers.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  className="text-center py-6 text-gray-500"
                >
                  No referred users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </ModalBody>
  </ModalContent>
</Modal>
    </div>
    
  );
};

const StatusBadge = ({ status }) => {
  const styles = {
    rewarded: "bg-green-100 text-green-700",
    active: "bg-yellow-100 text-yellow-700",
  };
  const labels = {
    rewarded: "Rewarded",
    active: "Active",
  };
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-bold ${styles[status] || "bg-gray-100 text-gray-700"}`}>
      {labels[status] || status}
    </span>
  );
};

export default ReferralList;
